import { Component, Prop, Vue, Watch, } from 'vue-property-decorator';

import { createLayerFromConfig } from 'tivigi/src/util/mapLayerLoading';

import { GoatClient } from '../GoatClient';

import * as ol from 'ol/'
import  * as ol_layer from 'ol/layer';
import * as ol_source from 'ol/source'

import WithRender from './AccessibilityHeatmap.html';



@WithRender
@Component({
    components: {
    },
})
export default class ActiveLayers extends Vue {

    //################# BEGIN Props #################
    @Prop()
    map!: ol.Map;

    @Prop()
    goatApi!:string;
    
    @Prop()
    exceptions!: Array<string>
    //################# END Props #################

    heatmapActive: boolean=false;
    activeLayers:any = null;
    heatmapLayer: any = null;
    heatmapId:string = "heatmap_default"

    onLayerAddEvent:any = null
    onLayerRemoveEvent:any = null

    // source layer config
    wmsConfig:any  = {
                        baseUrl: "https://geoserver.digitale-mrn.de/geoserver/metropolatlas/wms",
                        title: "Erreichbarkeit",
                        type: "wms-single",
                        level: 1,
                        showFeatureInfo: false,
                        properties:{
                                "percentile_accessibility": "Erreichbarkeits Score"
                        },
                        urlParams: {
                            layers: this.heatmapId
                        }   
                    }


    @Watch('map')
    onMapChange(){
         this.init()
    }

    mounted(){
        this.init()
    }

    init() {

        if(this.map == undefined){
            return
        }

        this.map.getLayers().on("remove", this.updateHeatmap)
        this.map.getLayers().on("add", this.updateHeatmap)
        
    }
    
    beforeDestory(){
        this.map.getLayers().un("remove", this.updateHeatmap)
        this.map.getLayers().un("add", this.updateHeatmap)
    }

    async updateHeatmap(){


        let layerIds:Array<any> = this.getLayers()

        // Abort and remove heatmap if nothing selected
        if(layerIds.length == 0){

            this.map.getLayers().getArray()
                        .filter(layer => layer.get('id') === this.heatmapId)
                        .forEach(layer => this.map.removeLayer(layer));

            this.activeLayers = []
            this.heatmapActive = false
            return
        }

        if(this.activeLayers != null){
            this.activeLayers.sort() 
            layerIds.sort()
        }
        // heatmap got removed
        if(this.activeLayers != null && layerIds.toString() == this.activeLayers.toString()){
            this.heatmapActive = false
            return
        }
        // set active Layers
        this.activeLayers = layerIds
        // this just updates the table in the database

        
        let goatClient = new GoatClient(this.goatApi)


        await goatClient.createHeatmap(layerIds)
        console.log('YES')

        this.heatmapLayer = createLayerFromConfig(this.wmsConfig, this.map.getView().getProjection())
        this.heatmapLayer.set("id", this.heatmapId)

        //######## Check again if heatmap active. Neccessary, otherwise heatmap will be loaded 5 times#############
        for (let layer of this.map.getLayers().getArray()) {
            if (layer.get('id') == this.heatmapId) {
                this.heatmapActive = true
            }
        }

        if(this.heatmapActive){

            this.map.getLayers().getArray()
            .filter(layer => layer.get('id') === this.heatmapId)
            .forEach(layer => ((layer as ol_layer.Image).getSource() as ol_source.ImageWMS).updateParams({'TIMESTAMP': new Date().getTime()}))
        }
        else{
            this.heatmapActive = true;
            this.map.addLayer(this.heatmapLayer)
            console.log(this.heatmapLayer)
        }

    }
    
    getLayers() {

        let layerIds: any = []


        for (let layer of this.map.getLayers().getArray()) {

            let showLegend = true

            if (layer.get('showLegend') != undefined) {
                showLegend = layer.get('showLegend')
            }

            if (showLegend && !(this.exceptions.includes(layer.get('id')))) {
                layerIds.push(layer.get('id'))
            }

            if(this.heatmapActive == false && layer.get('id') == this.heatmapId){
                this.heatmapActive = true
            }
        }


        return layerIds
    
    }

    
}




